module.exports = "/shifts/components/addAbsenceEvent-428053.html";